import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// routes
import { PATH_DASHBOARD, PATH_PAGE } from '../routes/paths';
// components
import LoadingScreen from '../components/loading-screen';
// context
import { useAuthContext } from './useAuthContext';
import { useEffect } from 'react';


// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticatedWithOAuth, isAuthenticatedOnBackend, isUserConnectedOnRainbow, isSSELinked, isError } = useAuthContext();


  if (isError) {
    return <Navigate to={PATH_PAGE.errorPage} />;
  }

  if (!isError && isAuthenticatedWithOAuth && isAuthenticatedOnBackend) {
    return <Navigate to={PATH_DASHBOARD.root} />;
  }

  if (!isError && isAuthenticatedWithOAuth && !isAuthenticatedOnBackend) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
